// import firebase from "firebase/app";
import { mapGetters } from "vuex";
// import "firebase/firestore";
import announcements from "@/frame/messages/mixins/announcements.js";
import routerFunctions from "@/data/functions/mixins/routerFunctions.js";
export default {
  computed: {
    // eslint-disable-next-line
    ...mapGetters(["getDataSource"])
  },
  mixins: [announcements, routerFunctions],
  methods: {
    doAfterSearching(results) {
      // Send to firestore
      if (results.length === 0) {
        // check snackbar text
        // if (this.getDataSource === "maintStrategy") {
        //   this.showSnackbar("No maintenance plans found.", "warning");
        // }
        // if (this.getDataSource === "Company Action") {
        //   this.showSnackbar("No actions found.", "warning");
        // }
        // // eslint-disable-next-line
        // if (this.getDataSource === "maintAssuranceImport" || this.getDataSource === "maintAssurance") {
        //   this.showSnackbar("No maintenance plans found.", "warning");
        // }
      } else {
        // CHANGE Store
        this.$store.dispatch("changeSearchResults", this.results);
        let router = this.defineRouter("K6"); // search
        // if (this.results[0].basic.tag === "U1") {
        //   router = this.defineRouter("K6.U1");
        // } else {
        //   router = this.defineRouter("K6"); // search
        // }
        this.$router.push(router);

        // // CHANGE Router
        // if (this.getDataSource === "maintStrategy") {
        //   this.$router.push("/maintstrategylist");
        // }
        // if (this.getDataSource === "Company Action") {
        //   this.$router.push("/actionslist");
        // }
        // if (this.getDataSource === "maintAssurance") {
        //   this.$router.push("/maintassurancelist");
        // }
      }
      // Stop All Spinners
      this.btnSpinSearchImport = false;
      this.enableSpinBtnAction = false;
      this.enableSpinnerGetMaintStrategy = false;
      this.btnSpinMaintAssuranceSearch = false;
    }
  }
};
